var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
import { templateRendering, getListeners, setRef, getRef } from '@progress/kendo-vue-common';
import { Keys, guid, validatePackage } from '@progress/kendo-vue-common';
import { getDirectParentId, isIdEmptyOrZeroLevel, EMPTY_ID, ZERO_LEVEL_ZERO_ITEM_ID, getRootParentId, getItemById } from '../utils/itemsIdsUtils';
import { prepareInputItemsForInternalWork } from '../utils/prepareInputItemsForInternalWork';
import { getNewItemIdUponKeyboardNavigation } from '../utils/getNewItemIdUponKeyboardNavigation';
import { getHoverOpenDelay, getHoverCloseDelay } from '../utils/hoverDelay';
import { MenuItemInternalsList } from './MenuItemInternalsList';
import { DirectionHolder } from '../utils/DirectionHolder';
import { MouseOverHandler } from '../utils/MouseOverHandler';
import { packageMetadata } from '../../package-metadata';
/**
 * @hidden
 */
var MenuVue2 = {
  name: 'KendoMenu',
  props: {
    vertical: {
      type: Boolean,
      default: false
    },
    items: Array,
    dir: String,
    hoverOpenDelay: {
      type: Number,
      default: undefined
    },
    hoverCloseDelay: {
      type: Number,
      default: undefined
    },
    openOnClick: Boolean,
    itemRender: [String, Object, Function],
    linkRender: [String, Object, Function],
    customCloseItemIds: Array
  },
  created: function created() {
    validatePackage(packageMetadata);
    this.mouseOverHandler = new MouseOverHandler(this.$props.openOnClick, this.reset, this.onItemMouseOver);
    // private itemHoverRequest: any;
    // private itemLeaveRequest: any;
    // private menuWrapperEl: any;
    this.guid = guid();
    this.directionHolder = new DirectionHolder();
    this.inputItems = [];
    this.currentItems = [];
    // private mouseOverHandler: MouseOverHandler;
  },

  mounted: function mounted() {
    this.isFirstRender = false;
    this.menuWrapperEl = getRef(this, 'menuWrapper');
  },
  updated: function updated() {
    // Reset the Menu upon big UI changes
    // to avoid misleading the user and to
    // keep the component consistent.
    // if (Boolean(prevProps.vertical) !== Boolean(this.$props.vertical) ||
    //     this.directionHolder.hasDirectionChanged()) {
    //     this.reset();
    // }
    this.mouseOverHandler.OpenOnClick = this.$props.openOnClick;
  },
  destroyed: !!isV3 ? undefined : function () {
    this.clearItemHoverAndLeaveRequestsIfApplicable();
  },
  // @ts-ignore
  unmounted: function unmounted() {
    this.clearItemHoverAndLeaveRequestsIfApplicable();
  },
  data: function data() {
    return {
      focusedItemId: EMPTY_ID,
      hoveredItemId: EMPTY_ID,
      tabbableItemId: ZERO_LEVEL_ZERO_ITEM_ID,
      isFirstRender: true
    };
  },
  computed: {
    menuClassName: function menuClassName() {
      return {
        'k-widget': true,
        'k-reset': true,
        'k-header': true,
        'k-menu': true,
        'k-menu-horizontal': !this.$props.vertical,
        'k-menu-vertical': this.$props.vertical
      };
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  render: function render(createElement) {
    var h = gh || createElement;
    this.prepareItems();
    if (!this.isFirstRender) {
      this.directionHolder.setIsDirectionRightToLeft(this.checkIsDirectionRightToLeft());
    }
    var lastItemIdToBeOpened = this.hoveredItemId ? this.hoveredItemId : this.focusedItemId ? getDirectParentId(this.focusedItemId) : EMPTY_ID;
    return h("div", {
      "class": this.getMenuWrapperClassName(),
      ref: setRef(this, 'menuWrapper')
    }, [
    // @ts-ignore
    h(MenuItemInternalsList, {
      "class": this.menuClassName,
      "aria-orientation": this.$props.vertical ? 'vertical' : undefined,
      attrs: this.v3 ? undefined : {
        "aria-orientation": this.$props.vertical ? 'vertical' : undefined,
        items: this.currentItems,
        isMenuVertical: this.$props.vertical,
        isDirectionRightToLeft: this.directionHolder.getIsDirectionRightToLeft(),
        focusedItemId: this.focusedItemId,
        lastItemIdToBeOpened: lastItemIdToBeOpened,
        tabbableItemId: this.tabbableItemId,
        itemRender: templateRendering.call(this, this.$props.itemRender, getListeners.call(this)),
        linkRender: templateRendering.call(this, this.$props.linkRender, getListeners.call(this)),
        menuGuid: this.guid,
        originalItemNeeded: this.getInputItem
      },
      items: this.currentItems,
      isMenuVertical: this.$props.vertical,
      isDirectionRightToLeft: this.directionHolder.getIsDirectionRightToLeft(),
      focusedItemId: this.focusedItemId,
      lastItemIdToBeOpened: lastItemIdToBeOpened,
      tabbableItemId: this.tabbableItemId,
      itemRender: templateRendering.call(this, this.$props.itemRender, getListeners.call(this)),
      linkRender: templateRendering.call(this, this.$props.linkRender, getListeners.call(this)),
      menuGuid: this.guid,
      onMouseleave: this.onItemMouseLeave,
      on: this.v3 ? undefined : {
        "mouseleave": this.onItemMouseLeave,
        "mouseover": this.onItemMouseOver,
        "mousedown": this.onItemMouseDown,
        "keydown": this.onKeyDown,
        "focus": this.onItemFocus,
        "click": this.onItemClick,
        "blur": this.onItemBlur
      },
      onMouseover: this.onItemMouseOver,
      onMousedown: this.onItemMouseDown,
      onKeydown: this.onKeyDown,
      onFocus: this.onItemFocus,
      onClick: this.onItemClick,
      onBlur: this.onItemBlur,
      originalItemNeeded: this.getInputItem
    })]);
  },
  methods: {
    reset: function reset() {
      this.clearItemHoverAndLeaveRequestsIfApplicable();
      this.focusedItemId = EMPTY_ID;
      this.hoveredItemId = EMPTY_ID;
      this.tabbableItemId = ZERO_LEVEL_ZERO_ITEM_ID;
    },
    onKeyDown: function onKeyDown(event) {
      // The focusedItemId may be empty when contentRender is used.
      // For example, content with input.
      if (this.focusedItemId !== EMPTY_ID) {
        var currentItem = getItemById(this.focusedItemId, this.currentItems);
        var newItemId = getNewItemIdUponKeyboardNavigation(this.currentItems, currentItem.id, event.keyCode, event.key, this.$props.vertical, this.directionHolder.getIsDirectionRightToLeft());
        if (currentItem.id !== newItemId) {
          event.preventDefault();
          this.setFocusedItemId(newItemId);
        }
        if ((event.keyCode === Keys.enter || event.keyCode === Keys.space) && !currentItem.disabled) {
          this.mouseOverHandler.handleItemSelectedViaKeyboard();
          this.dispatchSelectEventIfWired(event, currentItem.id);
          if (!event.defaultPrevented && currentItem.items.length === 0 && currentItem.url) {
            window.location.assign(currentItem.url);
          }
        }
      }
    },
    onItemMouseOver: function onItemMouseOver(itemId) {
      if (this.mouseOverHandler.IsMouseOverEnabled) {
        // The `over` event can get fired even without actually leaving the item.
        // For example, move the mouse little by little over the item content.
        this.clearItemHoverAndLeaveRequestsIfApplicable();
        var that_1 = this;
        this.itemHoverRequest = window.setTimeout(function () {
          that_1.setHoveredItemId(itemId);
          that_1.itemHoverRequest = null;
        }, getHoverOpenDelay(__assign({}, this.$props)));
      }
    },
    onItemMouseLeave: function onItemMouseLeave(itemId) {
      if (this.mouseOverHandler.IsMouseOverEnabled && this.isItemWithDefaultClose(itemId)) {
        // Both the `leave` and `hover` requests are cleared
        // to be defensive and consistent with the `over` handler.
        this.clearItemHoverAndLeaveRequestsIfApplicable();
        var that_2 = this;
        this.itemLeaveRequest = window.setTimeout(function () {
          that_2.setHoveredItemId(EMPTY_ID);
          that_2.itemLeaveRequest = null;
        }, getHoverCloseDelay(__assign({}, this.$props)));
      }
    },
    onItemMouseDown: function onItemMouseDown() {
      this.mouseOverHandler.handleItemMouseDown();
    },
    onItemFocus: function onItemFocus(itemId) {
      this.setFocusedItemId(itemId);
      this.mouseOverHandler.handleItemFocus();
    },
    onItemClick: function onItemClick(event, itemId) {
      var item = getItemById(itemId, this.currentItems);
      if (!item.disabled) {
        this.setFocusedItemId(itemId);
        this.mouseOverHandler.handleItemClick(itemId, this.isItemWithDefaultClose(itemId));
        this.dispatchSelectEventIfWired(event, itemId);
        if (!event.defaultPrevented && item.url) {
          window.location.assign(item.url);
        }
      }
    },
    onItemBlur: function onItemBlur(itemId) {
      if (this.isItemWithDefaultClose(itemId)) {
        this.setFocusedItemId(EMPTY_ID);
      }
    },
    getInputItem: function getInputItem(itemId) {
      return getItemById(itemId, this.inputItems);
    },
    setFocusedItemId: function setFocusedItemId(focusedItemId) {
      var tabbableItemId = focusedItemId === EMPTY_ID ? this.tabbableItemId : getRootParentId(focusedItemId);
      var hoveredItemId = focusedItemId === EMPTY_ID || isIdEmptyOrZeroLevel(this.hoveredItemId) && isIdEmptyOrZeroLevel(focusedItemId) ? this.hoveredItemId : EMPTY_ID;
      this.hoveredItemId = hoveredItemId;
      this.focusedItemId = focusedItemId;
      this.tabbableItemId = tabbableItemId;
    },
    setHoveredItemId: function setHoveredItemId(hoveredItemId) {
      if (isIdEmptyOrZeroLevel(hoveredItemId) && isIdEmptyOrZeroLevel(this.focusedItemId)) {
        this.hoveredItemId = hoveredItemId;
      } else {
        this.hoveredItemId = hoveredItemId;
        this.focusedItemId = EMPTY_ID;
        this.tabbableItemId = ZERO_LEVEL_ZERO_ITEM_ID;
      }
    },
    getMenuWrapperClassName: function getMenuWrapperClassName() {
      return {
        'k-rtl': this.directionHolder.getIsDirectionRightToLeft()
      };
    },
    clearItemHoverAndLeaveRequestsIfApplicable: function clearItemHoverAndLeaveRequestsIfApplicable() {
      if (this.itemHoverRequest) {
        clearTimeout(this.itemHoverRequest);
        this.itemHoverRequest = null;
      }
      if (this.itemLeaveRequest) {
        clearTimeout(this.itemLeaveRequest);
        this.itemLeaveRequest = null;
      }
    },
    isItemWithDefaultClose: function isItemWithDefaultClose(itemId) {
      return !this.$props.customCloseItemIds || this.$props.customCloseItemIds.indexOf(itemId) === -1;
    },
    checkIsDirectionRightToLeft: function checkIsDirectionRightToLeft() {
      return this.$props.dir !== undefined ? this.$props.dir === 'rtl' : this.menuWrapperEl && getComputedStyle(this.menuWrapperEl).direction === 'rtl';
    },
    prepareItems: function prepareItems() {
      var _a = prepareInputItemsForInternalWork.call(this, this.$props.items),
        items = _a.items,
        inputItems = _a.inputItems;
      this.currentItems = items;
      this.inputItems = inputItems;
    },
    dispatchSelectEventIfWired: function dispatchSelectEventIfWired(event, itemId) {
      this.$emit('select', {
        event: event,
        compontent: this,
        item: this.getInputItem(itemId),
        itemId: itemId
      });
    }
  }
};
/**
 *
 * Represents the [Kendo UI for Vue Menu component]({% slug overview_menu %}).
 *
 *
 * ### props <span class='code'>Readonly&lt;[MenuProps]({% slug api_layout_menuprops %})&gt;</span>
 * The props of the Menu component.
 *
 */
var Menu = MenuVue2;
export { Menu, MenuVue2 };